import { useTranslation } from 'react-i18next';
import { CollapseText } from '@components/collapse-text';
import { EventSummaryCard } from '@components/event-summary-card';
import { IconPerson, IconTicket } from '@components/icons';
import { formatOfflinePrice, totalOnlinePrice } from '@utils/calculate-booking-price';

import { HeaderEventFormSummaryProps } from './header-event-form-summary.type';

export const HeaderEventFormSummary = ({
  title,
  offer,
  quantity,
  selectedAddons,
  addons,
  event,
}: HeaderEventFormSummaryProps) => {
  const { t, i18n } = useTranslation();

  return (
    <header className='flex flex-col px-4 sm:px-20 pt-8 text-left'>
      <div className='flex flex-col gap-2 mb-4'>
        <p className='text-tertiary text-body-s'>{title}</p>
        <h2 className='text-headline-m line-clamp-2 text-primary'>{offer.displayName}</h2>
        {offer.displayDescription && (
          <CollapseText
            text={offer.displayDescription}
            expandText={t('common:viewMore')}
            collapseText={t('common:viewLess')}
          />
        )}
        <p className='flex text-body-s gap-2 text-secondary'>
          <span className='flex gap-1'>
            <IconPerson className='w-4 h-4' /> {t('invitations:guests', { count: quantity })}
          </span>
          <span className='flex gap-1'>
            <IconTicket className='w-4 h-4' />
            {t('offers:totalPriceValue', {
              price: totalOnlinePrice({ selectedAddons, quantity, addons, locale: i18n.language, offer }),
            })}
            {!!offer?.price?.offlinePrice &&
              t('offers:offlinePriceValue', {
                price: formatOfflinePrice({ offer, quantity }),
              })}
          </span>
        </p>
      </div>
      <EventSummaryCard
        name={event.name}
        startingTime={event.startingTime}
        coverUrl={event.coverUrl}
        clubName={event.club.name}
        locale={i18n.language}
        timezone={event.club.city.timezone}
      />
    </header>
  );
};
